<template>
  <swiper :options="swiperOption" v-cloak>
  <swiper-slide class="slide-1 ss">
  </swiper-slide>
  <swiper-slide class="slide-2 ss">
  </swiper-slide>
  <swiper-slide class="slide-3 ss">
  </swiper-slide>
  <swiper-slide class="slide-4 ss">
  </swiper-slide>
        <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
        <!-- <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div> -->
        <!-- <div class="swiper-button-next swiper-button-white" slot="button-next"></div> -->
  </swiper>
</template>

<script>
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'Swiper',
  components: { swiper },
  data () {
    return {
      swiperOption: {
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        loopedSlides: 4,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  }
}
</script>

<style scoped>
.swiper-container {
  background: #2d3436;
  height: 400px;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  width: 100%!important;
  height: 100%!important;
}
.slide-1 {
  background-image:url('../../../static/photos/OOSH_026.jpg');
}
.slide-2 {
  background-image:url('../../../static/photos/OOSH_007.jpg');
}
.slide-3 {
  background-image:url('../../../static/photos/OOSH_016.jpg');
}
.slide-4 {
  background-image:url('../../../static/photos/OOSH_025.jpg');
}
.ss {
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Swiper.vue